<div class="warn-type-header">{{header}} <span style="color: #888888">(Vorliegende Warnmeldungen:<strong
  style="color: #5d5c5c">{{unwetterWarnungen?.warnungen?.length}}</strong>)</span></div>

<div class="warn-type-subheader" *ngIf="unwetterWarnungen?.warnungen.length > 0">Warnungen</div>
<app-detail-expansion-panel [meldungen]="unwetterWarnungen?.warnungen"></app-detail-expansion-panel>
<div class="warn-type-subheader" *ngIf="unwetterWarnungen?.vorabinformationen?.length > 0">Vorabinformationen</div>
<app-detail-expansion-panel [isVorabInfo]="true"
                            [meldungen]="unwetterWarnungen?.vorabinformationen"></app-detail-expansion-panel>
